export default {"src":"/_next/static/media/prev-swiper-say.8e69b90e.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};